import { render } from "./DashboardGrid.vue?vue&type=template&id=627d11a4&scoped=true"
import script from "./DashboardGrid.vue?vue&type=script&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&lang=js"

import "./DashboardGrid.vue?vue&type=style&index=0&id=627d11a4&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627d11a4"]])

export default __exports__